<template>
  <el-popover
    width="270"
    popper-class="date-popover"
    trigger="click"
    v-model="visible"
    :disabled="disabled"
    placement="bottom-start"
  >
    <date
      :date="date"
      @change="change"
      :quarters="quarters"
      :halfYears="halfYears"
      :timeType="timeType"
      ref="date"
    ></date>
    <template slot="reference">
      <el-input
        :placeholder="placeholder"
        :disabled="disabled"
        v-model="showValue"
        size="mini"
        clearable
        prefix-icon="el-icon-date"
        @clear="clear"
      ></el-input>
    </template>
  </el-popover>
</template>
<script>
import Date from "@/components/BaseComponents/Date"
import { quarters, halfYears } from "@/components/BaseComponents/static"
import dj from "dayjs"
import { getHalf } from "@/utils/sheet"
let quarterOfYear = require("dayjs/plugin/quarterOfYear")
dj.extend(quarterOfYear)
export default {
  name: "date-popover",
  props: {
    placeholder: String,
    disabled: Boolean,
    date: String,
    timeType: String
  },
  components: {
    Date
  },
  data() {
    return {
      quarters,
      halfYears,
      showValue: "",
      visible: false
    }
  },
  watch: {
    date: {
      handler(newVal) {
        if (this.date) {
          switch (this.timeType) {
            case "半年度": {
              let halfYear = this.halfYears.find(halfYear => getHalf(this.date) === halfYear.value)
              this.showValue = this.date.slice(0, 4) + "年" + halfYear.label
              break
            }
            case "季度": {
              let quarter = this.quarters.find(quarter => dj(this.date).quarter() === quarter.value)
              this.showValue = this.date.slice(0, 4) + "年" + quarter.label
              break
            }
          }
        } else {
          this.showValue = ""
        }
      },
      immediate: true
    }
  },
  methods: {
    change(year, period) {
      let item =
        this.timeType === "半年度"
          ? this.halfYears.find(halfYear => halfYear.value === period)
          : this.quarters.find(quarter => quarter.value === period)
      this.showValue = year + "年" + item.label
      this.$emit("change", year + "-" + item.startTime)
    },
    clear() {
      this.$refs.date.getCurrent()
      this.$emit("change", null)
    }
  }
}
</script>

<style lang="scss">
.date-popover.el-popover {
  padding: 0;
  .el-input--mini {
    font-size: 14px;
  }
}
</style>
